import { SubmissionError } from 'redux-form/immutable';
import { sessionService } from 'redux-react-session';
import { replace } from 'react-router-redux';

import sessionApi from '../api/sessionApi';

export const login = user =>
  dispatch =>
    sessionApi.login({ user }).then((response) => {
      sessionService.saveUser(response)
      .then(() => {
        dispatch(replace('/'));
      });
    }).catch((err) => {
      throw new SubmissionError({
        _error: err.errors[0]
      });
    });

export const logout = () =>
  () =>
    sessionApi.logout().then(() => {
      sessionService.deleteUser();
      sessionService.deleteSession();
    }).catch((err) => {
      throw (err);
    });



// WEBPACK FOOTER //
// ./src/actions/sessionActions.js